module.exports = {
    remoteUrl: "https://irdevrestapi.azurewebsites.net/translations/beforeLogin"
}
